import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useCart } from "../context/CartContext";
import { toast } from "sonner";
import Stars from "./Stars";
import WishlistButton from "./WishlistButton";
import { formatPrice } from "../lib/format";

export default function ProductCard({ product }) {
  const { add } = useCart();
  const { t } = useTranslation();
  const lowStock = product.stock > 0 && product.stock <= 8;

  return (
    <div
      className="product-card group flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      <Link
        to={`/product/${product.id}`}
        className="block relative overflow-hidden bg-[#0A2A4F] aspect-[4/5] border border-white/5"
      >
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover product-card-img"
          loading="lazy"
        />
        <WishlistButton
          productId={product.id}
          productName={product.name}
          className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity"
          size={16}
        />
        {lowStock && (
          <div
            className="absolute top-2 left-2 bg-[#FF6B6B] text-white text-[9px] font-bold uppercase tracking-widest px-2 py-1"
            data-testid={`low-stock-${product.id}`}
          >
            {t("product.only_left", { count: product.stock })}
          </div>
        )}
        {product.stock === 0 && (
          <div className="absolute inset-0 bg-[#001F3F]/70 backdrop-blur-sm flex items-center justify-center">
            <span className="text-xs font-bold uppercase tracking-widest text-white border border-white/40 px-4 py-2">
              {t("common.out_of_stock")}
            </span>
          </div>
        )}
        {product.best_seller && product.stock > 0 && (
          <div
            className="absolute bottom-2 left-2 bg-[#FFD700] text-[#001F3F] text-[9px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 shadow-lg"
            data-testid={`best-seller-${product.id}`}
          >
            ★ Best-Seller
          </div>
        )}
      </Link>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#C5CDD8]">
            {product.category === "smart" ? "Smart Tech" : "Wellness"}
          </div>
          <Link
            to={`/product/${product.id}`}
            className="block mt-1 text-sm font-medium text-white hover:underline underline-offset-4 truncate"
            data-testid={`product-name-${product.id}`}
          >
            {product.name}
          </Link>
          {product.review_count > 0 && (
            <div className="mt-1.5 flex items-center gap-1.5">
              <Stars value={product.avg_rating} size={11} />
              <span className="text-[10px] text-white/50">
                ({product.review_count})
              </span>
            </div>
          )}
        </div>
        <div className="text-sm font-bold text-white whitespace-nowrap">
          {formatPrice(product.price)}
        </div>
      </div>
      <button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const hasVariants = (product.variants || []).length > 0;
          if (hasVariants) {
            // Navigate to PDP to let user choose a variant
            window.location.href = `/product/${product.id}`;
            return;
          }
          add(product, 1);
        }}
        disabled={product.stock === 0}
        className="mt-3 w-full border border-white/40 bg-transparent text-white hover:bg-white hover:text-[#001F3F] transition-all uppercase tracking-[0.25em] text-[10px] font-bold py-3 disabled:opacity-40 disabled:cursor-not-allowed"
        data-testid={`add-to-cart-${product.id}`}
      >
        {(product.variants || []).length > 0
          ? "Choisir une option"
          : t("common.add_to_cart")}
      </button>
    </div>
  );
}
